import styled from "styled-components";

export const ContactStyle = styled.section`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 600.78px;
    @media (max-width: 768px) {
        margin: 85px 0px 100px 0px;
    }

    .block-container {
        display: flex;
        gap: 50px;
        @media (max-width: 768px) {
            flex-direction: column;       
        }
    }

    .contact {
        display: flex;
        justify-content: center;
        flex-direction: column;
        @media (max-width: 768px) {
            width: 100vw;
            margin-left: 10px;
            text-align: center;
        }
    }

    a {
        text-decoration: none;
        color: black;
    }
    
    h4 {
        text-transform: uppercase;
    }
    .icon {
        width: 30px;
        height: 30px;
        margin-bottom: -9px;
    }

    .googlemaps {margin: auto;}
    .google-iframe {
        width: 450px;
        height: 450px;
        @media (max-width: 768px) {
            width: 100vw;
        }
    }
`